import { render, staticRenderFns } from "./SignificantEventListSlot.vue?vue&type=template&id=0a195354&scoped=true"
import script from "./SignificantEventListSlot.vue?vue&type=script&lang=js"
export * from "./SignificantEventListSlot.vue?vue&type=script&lang=js"
import style0 from "./SignificantEventListSlot.vue?vue&type=style&index=0&id=0a195354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a195354",
  null
  
)

export default component.exports